import { Link } from "react-router-dom";
import "@/components/franchise/franchise.css";

const SECTIONS = [
  ["Who we are", "Purnabramha franchise enquiries are handled by Purnabramha / MFPL (the Purnabramha franchisor team)."],
  ["What we collect", "When you submit a franchise enquiry: name, phone, email, city, country of residence, preferred follow-up method, your message and the configuration and indicative quote you reviewed. For community updates: name, email and/or phone, city and your stated interest. Viewing prices or downloading an indicative quote does not require personal details and does not create a record about you."],
  ["Why we use it", "To respond to your enquiry, discuss a possible franchise and prepare an individual proposal. Marketing messages are sent only if you separately opted in. Community-update details are used only to send those updates."],
  ["Who can see it", "Only authorised Purnabramha team members with admin access. Shared quote links are unguessable, can be revoked and may expire."],
  ["Storage", "Your contact details are stored on our servers, not in your browser. Only non-sensitive configurator choices are kept in your browser session so you don't lose your selections."],
  ["Your choices", "You may ask us to correct or delete your details, or withdraw marketing consent, by contacting us on WhatsApp/phone +91 97413 99190."],
];

export default function FranchisePrivacy() {
  return (
    <div className="fq-root min-h-screen">
      <main className="fq-wrap py-14 max-w-3xl" data-testid="privacy-notice">
        <Link to="/franchise" className="underline text-sm">← Back to franchise page</Link>
        <h1 className="font-display text-4xl text-[#3A0A06] mt-4">Franchise enquiry privacy notice</h1>
        <p className="text-xs opacity-70 mt-1">Version 2026-06-v1</p>
        {SECTIONS.map(([h, t]) => (
          <section key={h} className="mt-6"><h2 className="font-semibold text-lg text-[#3A0A06]">{h}</h2><p className="mt-1 text-sm leading-relaxed">{t}</p></section>
        ))}
      </main>
    </div>
  );
}
